import React from "react";
import {Link} from "react-router-dom";

const NotFound = () => (
    <div className="container-fluid not-found">
        <h1><span>4</span>0<span>4</span></h1>
        <p className="note">The page you are looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary btn-xl"><i className="icon-left"> </i>Back to Homepage</Link>
    </div>
);
export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.jsx